// src/components/TestSection.js
import React from 'react';

const TestSection = () => {
  return (
    <div>
      <h2>Test Section</h2>
      <p>This is a test section. You can add your testing content here.</p>
    </div>
  );
};

export default TestSection;
